
import React from 'react';
import styles from '../styles/TopBar.module.css';

interface TopBarProps {
    user: any;
    title?: string;
    systemStatus?: 'online' | 'offline' | 'warning';
}

const TopBar: React.FC<TopBarProps> = ({ user, title = 'Dashboard', systemStatus = 'online' }) => {
    const getInitials = (name: string) => {
        return name ? name.substring(0, 1).toUpperCase() : 'U';
    };

    const displayName = user?.given_name || user?.email || 'User';

    return (
        <header className={styles.topbar}>
            <div className={styles.title}>{title}</div>

            <div className={styles.actions}>
                <div className={styles.statusIndicator}>
                    <div className={`${styles.dot} ${styles[systemStatus]}`}></div>
                    System {systemStatus === 'online' ? 'Active' : systemStatus === 'offline' ? 'Offline' : 'Issues'}
                </div>

                <div className={styles.userProfile}>
                    <div className={styles.userInfo}>
                        <span className={styles.userName}>{displayName}</span>
                        <span className={styles.userRole}>Admin</span>
                    </div>
                    <div className={styles.avatar}>
                        {getInitials(displayName)}
                    </div>
                </div>
            </div>
        </header>
    );
};

export default TopBar;
